import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventSendToNlpNormalizers from '../normalizers/eventSendToNlpNormalizer';

export class SendToNlpRequest extends BaseApiPostRequest<
  {},
  EntityNormalizers.NormalizedSingleEntity<EventSendToNlpNormalizers.NormalizedEventsSendToNlpView>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super({ eventId }, component, dispatch);
    this.path = `/nlp/create-ceremony`;
    this.normalizeMethod = EventSendToNlpNormalizers.normalizeEventsSendToNLP;
  }
}
